import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import CustomersAPI, { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import UserWebAPIUtils, {
  generateSensitiveDocumentLinks,
} from 'utils/UserWebAPIUtils';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { useTranslation } from 'react-i18next';
import BillingForm from './carrier-billing';
import Sidebar from '../../carrier/AdminSidebar';
import { onSaveCustomerDetails } from '../customer-details';

const Loading = function () {
  return (
    <div className="justify-center lg:col-span-1" style={{ top: '50%' }}>
      <div className="align-middle">
        <span className="text-5xl text-green">
          <Spinner showMessage={false} />
        </span>
      </div>
    </div>
  );
};

const BillingSettings = () => {
  const { t } = useTranslation();
  const [carrier, setCarrier] = useState(null);
  const [sensitiveDocumentData, setSensitiveDocumentData] = useState(null);
  const params = useParams();
  const carrierId = params.id;
  const fetchUser = async () => {
    const user = await getCustomerV2(carrierId);
    if (user) {
      const {
        entity: { data: bankAccounts },
      } = await CustomersAPI.getBankAccounts(carrierId);

      if (bankAccounts) {
        user.bank_accounts = bankAccounts;
      }

      setCarrier(user);
    }
  };
  const renderSidebar = () => (
    <Sidebar userId={carrierId} activePage="billing" />
  );

  const breadcrumbs = {
    pages: [
      {
        name: carrier?.name || t('CARRIER'),
        href: `/users/${carrierId}`,
        current: false,
      },
      {
        name: 'Billing',
        href: `/users/${carrierId}/carrier-settings/billing`,
        current: true,
      },
    ],
  };
  const handleGetVerificationData = async () => {
    const stripeVerifiedDocuments = carrier?.stripe_verified_documents;
    const sensitiveDocuments = carrier?.sensitive_documents;
    if (
      (sensitiveDocuments && sensitiveDocuments.length) ||
      (stripeVerifiedDocuments && stripeVerifiedDocuments.length)
    ) {
      const verificationReports = await generateSensitiveDocumentLinks(
        carrier._id,
      );
      setSensitiveDocumentData(verificationReports.entity.results);
    }
  };
  const onSaveBankAccount = (data) => {
    data.userId = carrier._id;
    CustomersActionCreators.createBankAccount(data);
  };

  const handleBankingInfoAccept = () => {
    UserWebAPIUtils.updateBankingInfoStatus(
      carrier._id,
      carrier.stripe_verified_documents,
      true,
      '',
    );
    onSaveCustomerDetails('Carrier', {
      _id: carrier._id,
      all_banking_info_approved: true,
    });
  };

  const handleBankingInfoDecline = () => {
    UserWebAPIUtils.updateBankingInfoStatus(
      carrier._id,
      carrier.stripe_verified_documents,
      false,
      '',
    );
    onSaveCustomerDetails('Carrier', {
      _id: carrier._id,
      all_banking_info_approved: false,
    });
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {carrier ? (
        <AuthorizationWrapper excludedRegions={[REGIONS.AP]}>
          <div className="mb-6 col-span-1">
            <BillingForm
              details={carrier}
              onSave={onSaveBankAccount}
              // onSaveLegalEntity={this.props.onSaveLegalEntity}
              sensitiveDocumentData={sensitiveDocumentData}
              onHandleBankingInfoAccept={handleBankingInfoAccept}
              onHandleBankingInfoDecline={handleBankingInfoDecline}
              onGetVerificationData={handleGetVerificationData}
            />
          </div>
        </AuthorizationWrapper>
      ) : (
        <Loading />
      )}
    </LayoutWithSidebar>
  );
};

export default BillingSettings;
